// ---------------------------------------------------------------------------
// Estratto VERBATIM da TabPreventivi.tsx (Task #3874 — split interno Fase 2).
// Nessuna modifica logica: JSX spostato tale e quale, stato e handler restano
// nel componente padre e arrivano via props esplicite.
// ---------------------------------------------------------------------------
import type { Dispatch, SetStateAction } from 'react';
import { AlertTriangle } from 'lucide-react';
import type { NewQuoteDraft } from '../types';
// Task #3875 — DTO risposta condivisi (alias per minimizzare il churn).
import type {
  CrmMasterDuplicateWarning as DuplicateWarning,
  CrmMasterPipelineEntry as PipelineEntry,
} from '@easyflow/shared';
import { ModalWrapper } from '../shared';

interface DuplicateWarningDialogProps {
  duplicateWarning: DuplicateWarning[] | null;
  setDuplicateWarning: Dispatch<SetStateAction<DuplicateWarning[] | null>>;
  pendingLeadSelection: PipelineEntry | null;
  setPendingLeadSelection: Dispatch<SetStateAction<PipelineEntry | null>>;
  setNewQuote: Dispatch<SetStateAction<NewQuoteDraft>>;
  setClientSearch: Dispatch<SetStateAction<string>>;
  setClientType: Dispatch<SetStateAction<'tenant' | 'lead' | 'client' | ''>>;
}

export function DuplicateWarningDialog({
  duplicateWarning, setDuplicateWarning, pendingLeadSelection, setPendingLeadSelection,
  setNewQuote, setClientSearch, setClientType,
}: DuplicateWarningDialogProps) {
  return (
      <ModalWrapper open={!!duplicateWarning} onClose={() => { setDuplicateWarning(null); setPendingLeadSelection(null); }} title="Lead Duplicato">
        {duplicateWarning && (
          <div className="space-y-4">
            <div className="flex items-start gap-3 p-4 rounded-xl bg-amber-500/10 border border-amber-500/30">
              <AlertTriangle className="h-5 w-5 text-amber-400 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-semibold text-amber-300 mb-2">Esiste già un lead aperto con dati simili</p>
                {duplicateWarning.map((d, i: number) => (
                  <p key={i} className="text-xs text-amber-400/80">
                    {d.company_name || d.contact_name} {d.vat_number ? `(P.IVA: ${d.vat_number})` : ''} — Stage: {d.stage_name}
                  </p>
                ))}
                <p className="text-xs text-amber-400/60 mt-2">Vuoi procedere comunque?</p>
              </div>
            </div>
            <div className="flex justify-end gap-3">
              <button onClick={() => { setDuplicateWarning(null); setPendingLeadSelection(null); }} className="px-4 py-2 text-muted-foreground dark:text-muted-foreground/70 hover:text-foreground dark:hover:text-white">Annulla</button>
              <button onClick={() => {
                if (pendingLeadSelection) {
                  setNewQuote((q) => ({ ...q, tenant_id: '', pipeline_entry_id: pendingLeadSelection.id }));
                  setClientSearch(pendingLeadSelection.company_name || pendingLeadSelection.contact_name || 'Lead');
                  setClientType('lead');
                }
                setDuplicateWarning(null);
                setPendingLeadSelection(null);
              }} className="bg-amber-600 hover:bg-amber-700 text-white px-4 py-2 rounded-lg font-medium">Procedi comunque</button>
            </div>
          </div>
        )}
      </ModalWrapper>
  );
}
